import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';

const Switch = ({ checked, toggleChecked }) => {
  return (
    <button
      className={clsx(checked ? style.on : style.off)}
      onClick={toggleChecked}
    >
      <div className={style.switch}>
        <div className={style.dot}></div>
      </div>
    </button>
  );
};

export default Switch;
